import { differenceInDays, differenceInHours, differenceInMinutes, differenceInSeconds } from "date-fns";

export const calculateTime = (init: any, end: any) => {
  const inicio: any = new Date(init);
  const fim: any = new Date(end);
  const diferenca = new Date(fim - inicio);
  let resultado = diferenca.getUTCMinutes() + 'm ';
  resultado += diferenca.getUTCSeconds() + 's ';
  return resultado;
};

export function calculateTimeDifference(
  startDate: Date,
  endDate: Date,
): string {
  const days = differenceInDays(endDate, startDate);
  const hours = differenceInHours(endDate, startDate) % 24;
  const minutes = differenceInMinutes(endDate, startDate) % 60;
  const seconds = differenceInSeconds(endDate, startDate) % 60;

  const formattedTimeDifference = [
    days > 0 ? `${days}d` : '',
    hours > 0 ? `${hours}h` : '',
    minutes > 0 ? `${minutes}m` : '',
    seconds > 0 ? `${seconds}s` : '',
  ]
    .filter(part => part !== '')
    .join(' ');

  return formattedTimeDifference;
}
